window.anvil.block('media-gallery-1', el => {
    const sliderImages = el.querySelector('.slider-images');

    if (sliderImages) {
        new Swiper(sliderImages, {
            grabCursor: true,
            autoHeight: true,
            pagination: {
                el: el.querySelector('.js-indicator'),
                type: 'fraction',
                formatFractionCurrent: function (number) {
                    return ('0' + number).slice(-2);
                },
                formatFractionTotal: function (number) {
                    return ('0' + number).slice(-2);
                },
                renderFraction: function (currentClass, totalClass) {
                    return '<span class="' + currentClass + '"></span>' +
                        '/' +
                        '<span class="' + totalClass + '"></span>';
                }
            },
            navigation: {
                prevEl: el.querySelector('.js-prev'),
                nextEl: el.querySelector('.js-next'),
            }
        });
    }
});
